import { action } from 'typesafe-actions';
import { ReferralChannelsActionTypes, ReferralChannelParams } from 'types';

export const fetchReferralChannelsStart = (request: ReferralChannelParams) =>
  action(ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_START, request);

export const fetchReferralChannelsSuccess = (res: any) =>
  action(ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_SUCCESS, res);

export const fetchReferralChannelsFailure = (error: any) =>
  action(ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_FAILURE, error);

export const draftReferralChannelsStart = (request: ReferralChannelParams) =>
  action(ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_START, request);

export const draftReferralChannelsSuccess = (res: any) =>
  action(ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_SUCCESS, res);

export const draftReferralChannelsFailure = (error: any) =>
  action(ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_FAILURE, error);

export const activateReferralChannelsStart = (request: ReferralChannelParams) =>
  action(ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_START, request);

export const activateReferralChannelsSuccess = (res: any) =>
  action(ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_SUCCESS, res);

export const activateReferralChannelsFailure = (error: any) =>
  action(ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_FAILURE, error);

export const fetchGmlProjectionStart = () =>
  action(ReferralChannelsActionTypes.FETCH_GML_PROJECTION_START);

export const fetchGmlProjectionSuccess = (res: any) =>
  action(ReferralChannelsActionTypes.FETCH_GML_PROJECTION_SUCCESS, res);

export const fetchGmlProjectionFailure = (error: any) =>
  action(ReferralChannelsActionTypes.FETCH_GML_PROJECTION_FAILURE, error);

export const fetchActiveChannelByIdStart = (request: any) =>
  action(ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_START, request);

export const fetchActiveChannelByIdFaiure = (error: any) =>
  action(ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_FAILURE, error);

export const fetchActiveChannelByIdSuccess = (success: any) =>
  action(ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_SUCCESS, success);
